import "./index.scss";
import React, { useContext, useState } from "react";
import { AiOutlineClose, AiOutlineCheck } from "react-icons/ai";
import { Modal } from "src/component/Modal";
import { ScreenTitle, FlexRow, Button, TextInput, TextArea, AppLabel } from "src/style";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import ApiContext from "src/provider/API/call-service";

export const BroadcastModal = () => {
  const { visibility, setModal, notifier } = useContext(VisibilityContext);
  const { API } = useContext(ApiContext);

  const [mailSubject, setMailSubject] = useState("");

  const [message, setMessage] = useState("");

  // const onMessageChange = (e) => {
  //   setMessage(e);
  // };

  const handleCancel = () => {
    setMessage("");
    setMailSubject("");
    setModal({ key: "broadCastMail", value: false });
  };

  const handleSubmit = async () => {
  //   const response = await API.sendBroadcastMail({ mailSubject, message });
    // if (response) notifier.show(response, null, 'success');
  //   handleCancel();
  };

  return (
    <Modal
      isOnMenu
      className="view-result-modal"
      open={visibility.broadCastMail}
      cancel={handleCancel}
    >
      <ScreenTitle color="#712126" textSize="2" bottomMargin="4">
        Broadcast Mail
      </ScreenTitle>

      <AppLabel  
            textSize='1.2'
            fontWeight='600'
            color='#374957'
            >
              Mail Subject
            </AppLabel>

      <TextInput
        width="100%"
        borderColor="#8A8A8A"
        topPadding="1.2"
        leftPadding="2.5"
        rightPadding="2.5"
        bottomPadding="1.2"
        className="broadcast-mail-input"
        height="150px"
      >
        <input
          onChange={(e) => setMailSubject(e.target.value)}
          value={mailSubject}
          type="text"
          placeholder="Mail Subject"
        />
      </TextInput>

      {/* Message */}

      <div className="div">
        <AppLabel  
            textSize='1.2'
            fontWeight='600'
            color='#374957'
            >
              Message
            </AppLabel>
        <TextArea
          width="100%"
          borderColor="#8A8A8A"
          topPadding="1.2"
          leftPadding="2.5"
          rightPadding="2.5"
          bottomPadding="1.2"
          className="broadcast-mail-input"
        >
          <textarea
            placeholder="Enter your message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          ></textarea>
        </TextArea>
      </div>

      <FlexRow isMaxWidth>
        <FlexRow
          topMargin="2"
          justifyContent="space-between"
          className="btn-container"
        >
          <Button
            hoverColor="#A77B37"
            onClick={handleCancel}
            className="view-result-btn cancel"
          >
            <AiOutlineClose size={17} />
            Cancel
          </Button>
          <Button
            hoverBgColor="#fff"
            hoverColor="#A77B37"
            borderColor="#A77B37"
            onClick={handleSubmit}
            className="view-result-btn confirm"
          >
            <AiOutlineCheck size={17} />
            Confirm
          </Button>
        </FlexRow>
      </FlexRow>
    </Modal>
  );
};
